import http from '@/libs/http'

export function UpdatePassword (newPwd) {
  return http.put(`crm/system/passwordupdate?password=${newPwd}`)
}
